export const REMOTE_CONTROLLER_THROTTLE = 100; // ms
